export const MESSAGE_TYPES = {
    DECODE_IN_PROGRESS: 'decodeInProgress',
    DECODE_COMPLETED: 'decodeCompleted',
    INVALID_REQUEST: 'invalidRequest',
    HEARTBEAT: 'heartbeat',
    NO_CREDITS: 'noCredits',
    NO_USER: 'noUser',
};
